import * as React from "react";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import { styled } from "@mui/material/styles";
import { colors, tokens } from "../../../../utils";

const StyledTextField = styled(TextField)(({ theme }) => ({
  height: 40,
  width: "100%",
  marginLeft: "5px",
  backgroundColor: colors.white,
  "& .MuiInputBase-input": {
    color: "#212529 !important"
  },
  "& .MuiInputBase-root": {
    height: "100%",
    fontSize: "16px",
    lineHeight: "24px",
    fontFamily: "DM Sans, sans-serif",
    color: "#212529"
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "transparent",
      borderRadius: 5,
    },
    "&:hover fieldset": {
      borderColor: theme.palette.primary.main,
    },
    // ISP-9999 (gordon-0923-P1-REPEAT-kelly-field-focus-style-one-shared-
    // border-only-app-wide) — supersedes the fix-kelly-discount-code-
    // purple-focus-glow fix above (which pinned the notchedOutline
    // transparent and relied on the app-wide outline+box-shadow ring on the
    // input instead). Gordon's 2026-09-23 rule is the ONE shared data-field
    // effect: border recolor only, no outline, no box-shadow — matching the
    // Edit Wheel "Wheel Name" Froala reference field (src/theme/tokens.js
    // `dataFieldFocus`). This field's resting border is transparent (not a
    // real visible border), so recoloring it on focus is what GIVES it a
    // visible indicator for the first time, rather than risking removing
    // one. Still targets the CLASS `.MuiOutlinedInput-notchedOutline` (not
    // the bare `fieldset` type selector) for the same specificity reason
    // documented in muiSearchFieldFocusGlow.test.jsx.
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: tokens.dataFieldFocus.color,
    },
    "&.Mui-focused": {
      boxShadow: "none",
    },
  },
  "& .MuiOutlinedInput-input:focus-visible:focus-visible": {
    outline: "none",
    boxShadow: "none",
  },
}));

export default function MuiSearchField({
  placeholder = "",
  showIcon = true,
  iconPosition = "start",
  value = "",
  handleChange = () => {},
  sx = {},
  ...rest
}) {
  return (
    <StyledTextField
      placeholder={placeholder}
      value={value}
      onChange={(e) => handleChange(e.target.value)}
      sx={sx}
      InputProps={{
        startAdornment: showIcon ? (
          <InputAdornment position={iconPosition}>
            <SearchIcon />
          </InputAdornment>
        ) : null,
      }}
      {...rest}
    />
  );
}
